var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgAuthApple = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1484 9.4836C13.1559 8.90059 13.3108 8.32895 13.5986 7.82187C13.8864 7.31479 14.2978 6.88875 14.7945 6.58338C14.4789 6.13274 14.0627 5.76188 13.5787 5.50026C13.0948 5.23863 12.5565 5.09345 12.0066 5.07625C10.8337 4.95313 9.69658 5.77812 9.09885 5.77812C8.48957 5.77812 7.5693 5.08847 6.57831 5.10886C5.93732 5.12957 5.31262 5.31597 4.76508 5.64989C4.21754 5.98381 3.76584 6.45388 3.45398 7.01428C2.10311 9.35314 3.11074 12.7905 4.40478 14.6811C5.05222 15.6068 5.80888 16.6409 6.79898 16.6043C7.76784 16.5641 8.12969 15.9864 9.29918 15.9864C10.4578 15.9864 10.7973 16.6043 11.8075 16.5809C12.8471 16.5641 13.5021 15.6511 14.1269 14.7165C14.5921 14.0569 14.95 13.3279 15.1875 12.5564C14.5835 12.301 14.0681 11.8734 13.7055 11.3269C13.3428 10.7805 13.1491 10.1394 13.1484 9.4836Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2404 3.83298C11.8072 3.15249 12.0865 2.27784 12.0189 1.39478C11.1528 1.48573 10.3529 1.89964 9.77837 2.55401C9.49748 2.87369 9.28234 3.2456 9.14526 3.64847C9.00819 4.05135 8.95186 4.47729 8.97949 4.90194C9.41266 4.9064 9.84119 4.81251 10.2328 4.62735C10.6244 4.44219 10.9689 4.17058 11.2404 3.83298Z",
    fill: "white"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgAuthApple);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/auth-apple.ec43bf32240a0fda424d49e32697658a.svg";